module.exports = __webpack_public_path__ + "static/media/header-down-arrow.26c0b0db.svg";